import { IToken } from '../types/my-types';

export default function getPageFieldIsOnFromTokens(tokens: IToken[]) {
  if (!tokens) {
    return -1;
  }

  const pageIndex = tokens && tokens[0] && tokens[0].page - 1;

  return pageIndex === 0 ? pageIndex : pageIndex || -1;
}
